import { Injectable } from '@angular/core';
import { Company } from '../interfaces/company.interfaces';

import insuranceSrc from '!!file-loader!../assets/insurance.svg';
import calendarSrc from '!!file-loader!../assets/calendar.svg';
import paidorderSrc from '!!file-loader!../assets/paidorder.svg';

import logoWebp1 from '!!file-loader!../assets/companies/webp/logo-1.webp';
import logoWebp2 from '!!file-loader!../assets/companies/webp/logo-2.webp';
import logoWebp3 from '!!file-loader!../assets/companies/webp/logo-3.webp';
import logoWebp4 from '!!file-loader!../assets/companies/webp/logo-4.webp';
import logoWebp5 from '!!file-loader!../assets/companies/webp/logo-5.webp';
import logoWebp6 from '!!file-loader!../assets/companies/webp/logo-6.webp';
import logoWebp7 from '!!file-loader!../assets/companies/webp/logo-7.webp';
import logoWebp8 from '!!file-loader!../assets/companies/webp/logo-8.webp';
import logoWebp9 from '!!file-loader!../assets/companies/webp/logo-9.webp';
import logoWebp10 from '!!file-loader!../assets/companies/webp/logo-10.webp';
import logoWebp11 from '!!file-loader!../assets/companies/webp/logo-11.webp';
import logoWebp12 from '!!file-loader!../assets/companies/webp/logo-12.webp';
import logoWebp13 from '!!file-loader!../assets/companies/webp/logo-13.webp';
import logoWebp14 from '!!file-loader!../assets/companies/webp/logo-14.webp';
import logoWebp15 from '!!file-loader!../assets/companies/webp/logo-15.webp';
import logoWebp16 from '!!file-loader!../assets/companies/webp/logo-16.webp';
import logoWebp17 from '!!file-loader!../assets/companies/webp/logo-17.webp';
import logoWebp18 from '!!file-loader!../assets/companies/webp/logo-18.webp';
import logoWebp19 from '!!file-loader!../assets/companies/webp/logo-19.webp';
import logoWebp20 from '!!file-loader!../assets/companies/webp/logo-20.webp';
import logoWebp21 from '!!file-loader!../assets/companies/webp/logo-21.webp';
import logoWebp22 from '!!file-loader!../assets/companies/webp/logo-22.webp';
import logoWebp23 from '!!file-loader!../assets/companies/webp/logo-23.webp';
import logoWebp24 from '!!file-loader!../assets/companies/webp/logo-24.webp';
import logoWebp25 from '!!file-loader!../assets/companies/webp/logo-25.webp';
import logoWebp26 from '!!file-loader!../assets/companies/webp/logo-26.webp';
import logoWebp27 from '!!file-loader!../assets/companies/webp/logo-27.webp';

import logoPng1 from '!!file-loader!../assets/companies/png/logo-1.png';
import logoPng2 from '!!file-loader!../assets/companies/png/logo-2.png';
import logoPng3 from '!!file-loader!../assets/companies/png/logo-3.png';
import logoPng4 from '!!file-loader!../assets/companies/png/logo-4.png';
import logoPng5 from '!!file-loader!../assets/companies/png/logo-5.png';
import logoPng6 from '!!file-loader!../assets/companies/png/logo-6.png';
import logoPng7 from '!!file-loader!../assets/companies/png/logo-7.png';
import logoPng8 from '!!file-loader!../assets/companies/png/logo-8.png';
import logoPng9 from '!!file-loader!../assets/companies/png/logo-9.png';
import logoPng10 from '!!file-loader!../assets/companies/png/logo-10.png';
import logoPng11 from '!!file-loader!../assets/companies/png/logo-11.png';
import logoPng12 from '!!file-loader!../assets/companies/png/logo-12.png';
import logoPng13 from '!!file-loader!../assets/companies/png/logo-13.png';
import logoPng14 from '!!file-loader!../assets/companies/png/logo-14.png';
import logoPng15 from '!!file-loader!../assets/companies/png/logo-15.png';
import logoPng16 from '!!file-loader!../assets/companies/png/logo-16.png';
import logoPng17 from '!!file-loader!../assets/companies/png/logo-17.png';
import logoPng18 from '!!file-loader!../assets/companies/png/logo-18.png';
import logoPng19 from '!!file-loader!../assets/companies/png/logo-19.png';
import logoPng20 from '!!file-loader!../assets/companies/png/logo-20.png';
import logoPng21 from '!!file-loader!../assets/companies/png/logo-21.png';
import logoPng22 from '!!file-loader!../assets/companies/png/logo-22.png';
import logoPng23 from '!!file-loader!../assets/companies/png/logo-23.png';
import logoPng24 from '!!file-loader!../assets/companies/png/logo-24.png';
import logoPng25 from '!!file-loader!../assets/companies/png/logo-25.png';
import logoPng26 from '!!file-loader!../assets/companies/png/logo-26.png';
import logoPng27 from '!!file-loader!../assets/companies/png/logo-27.png';
import { BreadcrumbItem } from 'src/app/shared/modules/breadcrumb/types/breadcrumbItem';

@Injectable()
export class DmsRepositoryService {
  readonly title = 'Прием по ДМС';
  breadcrumbs: BreadcrumbItem[] = [
    { href: '/', text: 'Главная' },
    { href: '', text: this.title },
  ];

  readonly imagesSteps = {
    insuranceSrc,
    calendarSrc,
    paidorderSrc,
  };

  steps = [
    {
      title: 'Обратитесь в свою страховую компанию',
      image: `<div class="steps-icon icon"><img src="${this.imagesSteps.insuranceSrc}" alt="" /></div>`,
    },
    {
      title:
        'Согласуйте со страховой компанией список анализов, а также формат визита: в Центры Хеликс или вызов Мобильной службы на дом',
      image: `<div class="steps-icon icon"><img src="${this.imagesSteps.calendarSrc}" alt="" /></div>`,
    },
    {
      title: 'Ваш заказ будет оплачен страховой компанией',
      image: `<div class="steps-icon icon"><img src="${this.imagesSteps.paidorderSrc}" alt="" /></div>`,
    },
  ];

  listCompanies: Company[] = [
    {
      logoWebp: logoWebp1,
      logoPng: logoPng1,
      name: 'АО "АльфаСтрахование" Санкт-Петербургский филиал',
    },
    {
      logoWebp: logoWebp2,
      logoPng: logoPng2,
      name: 'ООО "БЕСТДОКТОР"',
    },
    {
      logoWebp: logoWebp3,
      logoPng: logoPng3,
      name: 'ООО "ВИТА-СТРАХОВАНИЕ"',
    },
    {
      logoWebp: logoWebp4,
      logoPng: logoPng4,
      name: 'САО "ВСК"',
    },
    {
      logoWebp: logoWebp5,
      logoPng: logoPng5,
      name: 'АО "ГСК "ЮГОРИЯ"',
    },
    {
      logoWebp: logoWebp6,
      logoPng: logoPng6,
      name: 'ООО "КАПИТАЛ ЛАЙФ СТРАХОВАНИЕ ЖИЗНИ"',
    },
    {
      logoWebp: logoWebp7,
      logoPng: logoPng7,
      name: 'ООО "КПСК"',
    },
    {
      logoWebp: logoWebp8,
      logoPng: logoPng8,
      name: 'ООО "РЕГИОН-МЕДСЕРВИС"',
    },
    {
      logoWebp: logoWebp9,
      logoPng: logoPng9,
      name: 'САО "РЕСО-ГАРАНТИЯ"',
    },
    {
      logoWebp: logoWebp10,
      logoPng: logoPng10,
      name: 'АО СГ "СПАССКИЕ ВОРОТА"',
    },
    {
      logoWebp: logoWebp11,
      logoPng: logoPng11,
      name: 'ООО "Aбсолют Cтрахование"',
    },
    {
      logoWebp: logoWebp12,
      logoPng: logoPng12,
      name: 'ООО СК "АЛЬЯНС ЖИЗНЬ"',
    },
    {
      logoWebp: logoWebp13,
      logoPng: logoPng13,
      name: 'Северо-Западный филиал ООО "Британский Страховой Дом"',
    },
    {
      logoWebp: logoWebp14,
      logoPng: logoPng14,
      name: 'АО "Страховая компания ГАЙДЕ"',
    },
    {
      logoWebp: logoWebp15,
      logoPng: logoPng15,
      name: 'ПАО "ГРУППА РЕНЕССАНС СТРАХОВАНИЕ"',
    },
    {
      logoWebp: logoWebp16,
      logoPng: logoPng16,
      name: 'СПАО "ИНГОССТРАХ"',
    },
    {
      logoWebp: logoWebp17,
      logoPng: logoPng17,
      name: 'ООО "Страховая компания «Капитал-полис»"',
    },
    {
      logoWebp: logoWebp18,
      logoPng: logoPng18,
      name: 'ООО "МЕДОБЛАКО"',
    },
    {
      logoWebp: logoWebp19,
      logoPng: logoPng19,
      name: 'САО "МЕДЭКСПРЕСС"',
    },
    {
      logoWebp: logoWebp20,
      logoPng: logoPng20,
      name: 'ООО "НМС"',
    },
    {
      logoWebp: logoWebp21,
      logoPng: logoPng21,
      name: 'Филиал «Адвант» Акционерного общества «Страховая компания «ПАРИ» в городе Санкт-Петербурге',
    },
    {
      logoWebp: logoWebp22,
      logoPng: logoPng22,
      name: 'ООО "ПСБ СТРАХОВАНИЕ"',
    },
    {
      logoWebp: logoWebp23,
      logoPng: logoPng23,
      name: 'ПАО СК "РОСГОССТРАХ"',
    },
    {
      logoWebp: logoWebp24,
      logoPng: logoPng24,
      name: 'АО "Страховое общество газовой промышленности"',
    },
    {
      logoWebp: logoWebp25,
      logoPng: logoPng25,
      name: 'ООО "СК "Согласие"',
    },
    {
      logoWebp: logoWebp26,
      logoPng: logoPng26,
      name: 'ПАО "САК "ЭНЕРГОГАРАНТ"',
    },
    {
      logoWebp: logoWebp27,
      logoPng: logoPng27,
      name: 'АО "СОВКОМБАНК СТРАХОВАНИЕ"',
    },
  ];
}
